import React, { type FC, memo } from "react";
import { useDisclaimers } from "../../../hooks/useDisclaimers";
import Container from "../../../../shared-components/css-modules/lexus/atoms/Container";
import Disclaimer from "./Disclaimer";
import styles from "./Disclaimers.module.scss";
import { IntegratedLegalBannerDisclaimer } from "../../../../../shared-components/lexus/IntegratedLegalBannerDisclaimer";

const Disclaimers: FC = () => {
    const { items, legalBannerDisclaimerData } = useDisclaimers();

    if (items.length === 0 && !legalBannerDisclaimerData) {
        return null;
    }

    return (
        <Container className={styles.container}>
            {legalBannerDisclaimerData && <IntegratedLegalBannerDisclaimer data={legalBannerDisclaimerData} />}
            {items.length > 0 && (
                <div className={styles.disclaimers}>
                    {items.map((disclaimer) => (
                        <Disclaimer key={disclaimer.id} disclaimer={disclaimer} />
                    ))}
                </div>
            )}
        </Container>
    );
};

export default memo(Disclaimers);
